import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../loader';
import 'react-rangeslider/lib/index.css';
import "react-phone-number-input/style.css";
import { sendPromoNotifications, fetchSubscribersToReceivePromo } from "../../actions/subscribeToPet";

const $ = window.$;
const initialState={
  currentFormNotValid: false,
  petId: 'Specific',
  customPetId: '',
  notify_changes: true,
  notify_arrivals: true,
  message: '',
  loading: false,
  subscriberCount: null,
  exclude_contract_customers: false
};
let formdata = {};
class MessageToSubscribers extends React.Component {
  constructor(props) {
    super(props);
  }

  state = initialState;

  submitMessage = async(e) => {
    e.preventDefault();
    this.setState({loading:true});
    
    if (this.validateForm()) {
        let data = Object.values(formdata).map(key => {
            if (key !== null && key !== '') {
                return true;
            }
            else {
                return false;
            }
        });

        if (!data.includes(false)) {
            this.props.sendPromoNotifications(formdata);
        }else {
            this.setState({ currentFormNotValid: true });
            this.setState({ loading: false });
            NotificationManager.warning("Please check input details again.");
        }
    }
  }
  validateForm(){
    const data = {
      petId: this.state.petId,
      notify_changes: this.state.notify_changes,
      notify_arrivals: this.state.notify_arrivals,
      message: this.state.message,
      exclude_contract_customers: this.state.exclude_contract_customers
    }

    if(this.state.petId === "Specific"){
        data["customPetId"] = this.state.customPetId;
    }
    
    formdata = Object.assign({},data);
    return true;
  }
  changeVal = (event) => {
    if(event.target.dataset.limit){
      if(event.target.dataset.limit >= event.target.value.length){
        this.setState({[event.target.name]: event.target.value, subscriberCount: null});
      }else{
        event.target.value = event.target.value.slice(0, event.target.dataset.limit);
      }
    }else{
      this.setState({[event.target.name]: event.target.value, subscriberCount: null});
    }

  }

  changeValCheckBox = (event) => {
    this.setState({[event.target.name]: event.target.checked, subscriberCount: null});
  }

  resetState = () => {
    this.setState(initialState);
  }

  componentWillReceiveProps = (nextProps) => {
    if (
        nextProps.data.subscribeToPetReducer.sendPromocodeToSubscribers !==
        this.props.data.subscribeToPetReducer.sendPromocodeToSubscribers
      ) {
        this.setState(initialState);
        let sendPromocodeToSubscribers = nextProps.data.subscribeToPetReducer.sendPromocodeToSubscribers;
        let messageLength = sendPromocodeToSubscribers && sendPromocodeToSubscribers.length;
        NotificationManager.success("Message Sent to "+ messageLength +" Subscribers.");
        
        $('#message-to-subscribers').modal('hide');
      }

    if (
      nextProps.data.subscribeToPetReducer.promoSubscribers !==
      this.props.data.subscribeToPetReducer.promoSubscribers
    ) {
      let promoSubscribers = nextProps.data.subscribeToPetReducer.promoSubscribers;
      let promoSubscriberLength = promoSubscribers && promoSubscribers.length;
      this.setState({subscriberCount: promoSubscriberLength});
    } 

    if (
      nextProps.data.subscribeToPetReducer.promoSubscribersError !==
      this.props.data.subscribeToPetReducer.promoSubscribersError
    ) {
      let errorMessage = nextProps.data.subscribeToPetReducer.promoSubscribersError && nextProps.data.subscribeToPetReducer.promoSubscribersError.details
      NotificationManager.error(errorMessage);
    } 
  }

  getSubscriberCount = () => {
    if (this.validateForm()) {
        let data = Object.values(formdata).map(key => {
            if (key !== null && key !== '') {
                return true;
            }
            else {
                return false;
            }
        });

        if (!data.includes(false)) {
          this.props.fetchSubscribersToReceivePromo(formdata);
        }else {
            this.setState({ currentFormNotValid: true });
            this.setState({ loading: false });
            NotificationManager.warning("Please check input details again.");
        }
    }
    
  }

  render() {
    const {petId, notify_changes, notify_arrivals, message, customPetId, subscriberCount, exclude_contract_customers} = this.state;

    return (
      <div className="modal fade show" id="message-to-subscribers" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            
              <form onSubmit={this.submitMessage} className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Message Subscribers</h5>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  
                    <div className="row">
                      <div className="col-xl-8 offset-xl-2">
                          <div className="m-form__section m-form__section--first">
                          <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Send to</legend>
                              <div className="form-group m-form__group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label">* Pet ID:</label>
                                    <div className="col-xl-9 col-lg-9">
                                    
                                        <select className="form-control m-input" onChange={this.changeVal} name="petId" value={petId} id="petId">
                                            <option>All</option>
                                            <option selected="selected">Specific</option>
                                        </select>
                                        { petId === "Specific" ? 
                                        <>
                                        <br/>
                                        <input type="text" name="customPetId" onChange={this.changeVal} className="form-control m-input" placeholder="" value={customPetId}/>
                                        <span className={formdata.customPetId===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter the pet id</span>
                                        </> : <span className='m-form__help'>Please select option</span>
                                        }
                                  </div>
                              </div>
                              <div className="form-group m-form__group row">
                                <div className="col-xl-3 col-lg-3">
                                  <div className="row">
                                    
                                  </div>
                                </div>
                                <div className="col-xl-9 col-lg-9">
                                  <div className="row">
                                    <div className="col-1 col-lg-1 col-form-label" style={{textAlign: "center"}}>
                                      <input type="checkbox" name="notify_changes" onChange={this.changeValCheckBox} checked={notify_changes}/>
                                    </div>
                                    <label className="col-4 col-lg-4 col-form-label">Available Pet Subscribers</label>
                                    <div className="col-1 col-lg-1 col-form-label" style={{textAlign: "center"}}>
                                      <input type="checkbox" name="notify_arrivals" onChange={this.changeValCheckBox} checked={notify_arrivals}/>
                                    </div>
                                    <label className="col-4 col-lg-4 col-form-label">New Arrival Subscribers</label>
                                  </div>
                                </div>
                              </div>
                            </fieldset>  
                            <div className="form-group m-form__group row">
                              <label className="col-3 col-lg-3 col-form-label">* Message:</label>
                              <div className="col-9 col-lg-9">
                                <textarea name="message" onChange={this.changeVal} className="form-control m-input" data-limit="250" value={message} />
                                <span className="row">
                                  <span className={formdata.message===null&&this.state.currentFormNotValid?'m-form__help_danger col-xl-6 col-lg-6':'m-form__help col-xl-6 col-lg-6'}>Please enter the message</span>
                                  <span className='m-form__help col-xl-6 col-lg-6' style={{textAlign: "right"}}>{message !== null ? message.length : 0}/250</span>
                                </span>
                              </div>
                            </div>
                            <div className="form-group m-form__group row">
                                <div className="col-xs-3 col-lg-3">
                                  <div className="row">
                                    
                                  </div>
                                </div>
                                <div className="col-xs-9 col-lg-9">
                                  <div className="row">
                                    <div className="col-1 col-lg-1 col-form-label" style={{textAlign: "center"}}>
                                      <input type="checkbox" name="exclude_contract_customers" onChange={this.changeValCheckBox} checked={exclude_contract_customers}/>
                                    </div>
                                    <label className="col-10 col-lg-11 col-form-label">Exclude customers who recently purchased a pet</label>
                                  </div>
                                </div>
                              </div>
                            <div className="form-group m-form__group row">
                              <div className="col-xs-3 col-lg-3 col-form-label"></div>
                              <div className="col-xs-9 col-lg-9">
                                <button type="button" className="btn btn-secondary m-btn--pill" onClick={this.getSubscriberCount} style={{border: "1px #afafaf solid"}}>Get Subscriber Count</button>
                                {subscriberCount !== null ? 
                                  <>
                                    {subscriberCount > 0 ?
                                      <span className='m-form__help' style={{fontSize: "13px", width: "100%"}}>The message will be sent to <span className="m-badge m-badge--success mx-auto my-0 px-4" style={{fontWeight: "bold"}}>{subscriberCount}</span>.</span>
                                      : 
                                      <span className='m-form__help' style={{fontSize: "13px", width: "100%"}}>No Subscribers Found.</span>
                                    }
                                  </>
                                  : ""
                                }
                                
                              </div>
                            </div>
                          </div>	          
                      </div>
                    </div>
                </div>
                <div className="modal-footer">
                  {this.state.loading == false ?
                    <div>
                      <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Close</button>
                      <button type="submit" className="btn btn-primary m-btn--pill" disabled={subscriberCount === null || subscriberCount === 0 ? true : false}>Send</button>
                    </div>
                    :
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  }
                </div>
              </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
    data: state
});

const mapDispatchToProps = dispatch => ({
  sendPromoNotifications: (data) => {
      dispatch(sendPromoNotifications(data));
  },
  fetchSubscribersToReceivePromo: (data) => {
    dispatch(fetchSubscribersToReceivePromo(data));
  }
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessageToSubscribers));
